
const pricing = {
  // Pricing
  pricing: {
    title: "Choose Your Plan",
    subtitle: "Select the perfect plan to unlock the full potential of AI-powered sports predictions.",
    monthly: "Monthly",
    annual: "Annual",
    year: "year",
    month: "month",
    popular: "Most Popular",
    annualDiscount: "Save 20% with annual billing",
    saveText: "Save 20%",
    getStarted: "Get Started",
    info: "More info",
    basic: "Basic",
    basicDescription: "Perfect for casual bettors getting started with AI predictions",
    pro: "Pro",
    proDescription: "Ideal for serious bettors who want advanced analytics and insights",
    ultimate: "Ultimate",
    ultimateDescription: "Complete solution for professional bettors and betting groups",
    questionsTitle: "Have Questions?",
    questionsText: "Our support team is here to help you choose the right plan and get the most out of Titan Predictions.",
    contactSupport: "Contact Support",
    features: {
      dailyPredictions: "Daily Predictions",
      dailyPredictionsDesc: "Access to daily match predictions with basic probability analysis",
      basicStats: "Basic Statistics",
      basicStatsDesc: "Essential team and player statistics for informed betting decisions",
      matchAlerts: "Match Alerts",
      matchAlertsDesc: "Get notified about important matches and betting opportunities",
      advancedAnalytics: "Advanced Analytics",
      advancedAnalyticsDesc: "Deep statistical analysis with trend identification and pattern recognition",
      titanEngine: "Titan Engine Access",
      titanEngineDesc: "Full access to our AI-powered prediction engine with real-time analysis",
      ticketGenerator: "Smart Ticket Generator",
      ticketGeneratorDesc: "Automated bet combination suggestions based on AI analysis and risk management",
      prioritySupport: "Priority Support",
      prioritySupportDesc: "24/7 premium support with dedicated account management and consultation"
    }
  }
};

export default pricing;
